// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const DateRange = t.struct({
    from: t.maybe(t.Number),
    max: t.maybe(t.Number),
    min: t.maybe(t.Number),
    to: t.maybe(t.Number)
}, {
    name: 'DateRange',
    strict: true
});

export const getDefaultState = () => new DateRange({
    from: null,
    max: null,
    min: null,
    to: null
});

DateRange.prototype.isWithinRange = function isWithinRage(date) {

    return date >= this.from && date <= this.to;

};

export default DateRange;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/date-range.js